import { TitleRowTabBeneficiaries } from 'components/TitleRowTabBeneficiaries';
import { useGetTabEmployedsQuery } from 'redux/Api/employedsWorkSupportApi/employedsWorkSupportApi';
import { TaxesEmployedsItem } from 'ui/TaxesEmployedsItem';
import { LoadingSkeleton } from 'components/LoadingSkeleton';
import { Nothing } from 'components/Nothing';
import styles from './Taxes.module.scss';
import {
  QueryParamsTabEmployedsType,
  ResponseTabEmployedsTaxeType,
} from 'redux/Api/employedsWorkSupportApi/type';

export const Taxes = ({ id = 0, title }: QueryParamsTabEmployedsType) => {
  const { data, isLoading, error } = useGetTabEmployedsQuery({ id, title });

  const dataTaxes = ['id', 'Сумма', 'Заказчик', 'Удержано', 'Оплачено', 'Статус платежа'];

  return (
    <div className={styles.root}>
      <TitleRowTabBeneficiaries data={dataTaxes} title='taxesEmployeds' />
      {error || !data?.length ? (
        <Nothing
          style={{ height: '640px' }}
          title={error ? 'Ошибка, попробуйте позже' : 'Ничего не найдено'}
        />
      ) : isLoading ? (
        <LoadingSkeleton tabDetails />
      ) : (
        (data as ResponseTabEmployedsTaxeType[])?.map((elem, i) => (
          <TaxesEmployedsItem taxe={elem} key={i} />
        ))
      )}
    </div>
  );
};
